'use strict';

ossUnderline.$inject = ['$timeout', '$window'];

function ossUnderline($timeout, $window) {
    var directive = {
        restrict: 'A',
        link: link
    };

    return directive;

    function link(scope, element, attrs) {
        var timer = null;
        var parent = element.parent()[0];
        var menuItems = parent.getElementsByClassName('steps__cell--link');

        function moveToActiveEl() {
            if (scope.currentStateNumber < 0) return;
            var activeItemIdx = scope.getStateDisplayNumber(scope.currentStateNumber) - 1;
            var activeItem = menuItems[activeItemIdx];
            if (activeItem) {
                element.css({ "width": activeItem.clientWidth, "left": activeItem.offsetLeft });
            }
        }

        function onResize() {
            element.removeClass('ng-enter');
            $timeout.cancel(timer);
            timer = $timeout(function () {
                moveToActiveEl();
            }, 20);
        }

        scope.$watch('currentStateNumber', function (newValue, oldValue) {
            if (newValue == -1) return;
            if (newValue !== oldValue) {
                element.addClass('ng-enter');
            }
            moveToActiveEl();
        });

        angular.element($window).on('resize', onResize);

        scope.$on('$destroy', function (event) {
            $timeout.cancel(timer);
            angular.element($window).off('resize', onResize);
        });
    }
}

module.exports = ossUnderline;